import { datalayerInstance } from '../../';
import categoryPageAttributes from '../../category-page-attributes';

export const categoryPageEngagementDatalayer =  ({ ...props }) => {
  datalayerInstance().add({
    name: 'category',
    data: categoryPageAttributes(props),
  });
};
